import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import { GetTransactionBonusesDTO } from "./models";

export const GetTransactionBonuses = async (dto: GetTransactionBonusesDTO) => {
  const { data } = await api.post(
    API_ROUTES.TRANSACTION_BONUSES,
    qs.stringify({ ...defaultOptions(), activated: 2, ...dto })
  );

  return data;
};
